import { mergeAttributes, Node } from '@tiptap/core';
import type { Node as PMNode } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';

export interface SectionRepeaterOptions {
  HTMLAttributes: Record<string, any>;
}

export const SectionRepeater = Node.create<SectionRepeaterOptions>({
  name: 'SectionRepeater',
  content: 'block+',
  allowGapCursor: false,
  selectable: true,
  isolating: true,
  group: 'block',

  addAttributes() {
    return {
      parentId: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-parentid'),
        renderHTML: (attributes: Record<string, any>) => {
          return {
            'data-parentid': attributes.parentId,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `div`,
        getAttrs: (node: string | HTMLElement) =>
          node instanceof HTMLElement && node.getAttribute('data-type') === 'section-repeater' && null,
      },
    ];
  },

  renderHTML({ HTMLAttributes }: any) {
    return ['div', mergeAttributes({ 'data-type': 'section-repeater' }, HTMLAttributes), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(() => (
      <NodeViewWrapper>
        <NodeViewContent className="rounded-md" />
      </NodeViewWrapper>
    ));
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('eventHandler'),
        filterTransaction: (transaction, state) => {
          let result = true; // true for keep, false for stop transaction

          const {
            doc: { content },
          } = transaction;

          content.forEach((node) => {
            if (node.type.name === 'SectionRepeater') {
              const correspondingSectionRepeaters: PMNode[] = [];

              state.doc.content.forEach((stateNode) => {
                if (stateNode.type.name === 'SectionRepeater' && stateNode.attrs.parentId === node.attrs.parentId) {
                  correspondingSectionRepeaters.push(stateNode);
                }
              });

              correspondingSectionRepeaters.forEach((sectionRepeaterNode) => {
                if (sectionRepeaterNode.childCount !== node.childCount) {
                  result = false;
                }
              });
            }
          });

          return result;
        },
      }),
    ];
  },
});
